import React from "react";
//#region components
import { Skeleton } from "@mui/material";
import AccordionPanel from "../panels/accordianPanel";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const AccordianPanelSkeleton: React.FC = (props) => {
  return (
    <AccordionPanel
      title={<Skeleton width="100px" height="8px" />}
      className={cssExports.accordionPanelSkeleton}
    ></AccordionPanel>
  );
};

export default AccordianPanelSkeleton;
